import React from 'react';
import '../../styles/AboutUs.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import AboutFeature1 from '../../assets/AboutUs1.webp';
import AboutFeature2 from '../../assets/AboutUs4.webp';

const AboutUs = () => {

  return (
    <>
      {/* Hero Section */}
      <section className="about-section">
        <div className="container py-5">
         

          {/* Why Choose Us Section */}
          <div className="row align-items-center mb-5 py-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img 
                src={AboutFeature1} 
                alt="RCS Logistics operations" 
                className="img-fluid about-image"
              />
            </div>
            <div className="col-lg-6">
              <div className="about-card">
                <button disabled className="header-button mb-4">
                  WHY CHOOSE US
                </button>
                <h2 className="section-title mb-4">
                  Global Experience, Local Expertise
                </h2>
                <p className="text-muted lh-base section-text">
                  A wealth of global experience. A hard-nosed, hands-on approach. A predilection for nuance
                  and detail. A deep respect for efficiency. When you work with us, you work with a hyperfocused
                  company committed to performance and delivery. We believe each client is special,
                  each piece of cargo essential, each need distinct. And we make sure it doesn't go unnoticed.
                </p>
              </div>
            </div>
          </div>

          {/* What We Do Section */}
          <div className="row align-items-center mb-5 py-5">
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <img 
                src={AboutFeature2} 
                alt="RCS Logistics team" 
                className="img-fluid about-image"
              />
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="about-card">
                <button disabled className="header-button mb-4">
                  WHAT WE DO
                </button>
                <h2 className="section-title mb-4">
                  Strategic Solutions for Complex Challenges
                </h2>
                <p className="text-muted lh-base section-text">
                  Our highly skilled management team is dedicated to your business's success, equipped to handle complex challenges with strategic, tailored solutions. With a hands-on approach, 
                  we ensure every project is executed efficiently and professionally, giving you confidence that your business is in capable hands.
                </p>
              </div>
            </div>
          </div>

          {/* Our Values Section */}
          <div className="row mt-5 pt-5">
            <div className="col-12 text-center mb-5">
              <button disabled className="header-button mb-4">
                OUR VALUES
              </button>
              <h2 className="large-section-title mb-4">
                What Drives Us Forward
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="icon-container">
                  <i className="fas fa-handshake value-icon"></i>
                </div>
                <h4 className="value-title mb-3">Reliability</h4>
                <p className="text-muted">
                  We deliver on our promises with unwavering commitment to excellence and timely execution.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="icon-container">
                  <i className="fas fa-lightbulb value-icon"></i>
                </div>
                <h4 className="value-title mb-3">Innovation</h4>
                <p className="text-muted">
                  We continuously evolve our methods and technologies to provide cutting-edge logistics solutions.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="icon-container">
                  <i className="fas fa-users value-icon"></i>
                </div>
                <h4 className="value-title mb-3">Partnership</h4>
                <p className="text-muted">
                  We treat our clients as partners, working together to achieve mutual success and growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Statement Section */}
      <section className="mission-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="mission-card">
                <button disabled className="header-button mb-4">
                  OUR MISSION
                </button>
                <h2 className="mission-title mb-4">
                  Connecting the World Through Logistics Excellence
                </h2>
                <p className="text-muted fs-5 lh-base mx-auto mission-text">
                  We are a logistics provider dedicated to delivering services at high, uncompromising
                  standards. We also value efficiency, which is why each of our offices is designed to operate
                  with great autonomy and point-blank precision. We prefer to operate as people rather than as
                  a bureaucracy, and that's why we consistently yield great results at record response time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;